<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading" id="acknowledgments">
<div class="heading heading-with-title heading-without-image" id="acknowledgments-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Acknowledgments</h1>
</div>
</div>
</div>
</div>
<div class="text" id="acknowledgments-text">
<p class="first first-in-chapter first-full-width"><b>J. L. Woodson</b></p>
<p class="subsq">I’d like to first and foremost thank God, for placing the blessing of creativity within. I’d like to thank my Mother Naleighna Kai for finding creative ways to get me back into writing and supporting me. Thank you to my woman Donisha Moss for being a big support and giving me the space to vent and express ideas. A big thank you to Martha Kennerson for helping me with this project. Thanks to my editors and beta readers, Janice M. Allen, Debra J. Mitchell, Kelsie Maxwell, J. L. Campbell, April Bubb. To the Tribe Family, thank you for always supporting me. To Auntie Linda, Sesvalah, Janine, Mama Frankie. I’d like to thank my family as well, my cousins J.S. Cole and Hiram Harris. Thank you to my Aunt Monica, Cousins Erica, Lisa, and Amanda for supporting me and making me smile and always sharing our Grandma Goose’s story with me. Thanks to my Grandpa Al for sharing his experiences with me in his journey to Chicago.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width"><b>Martha Kennerson</b></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">It has been a great privilege to be a part of this project. I’d like to acknowledge my writing team Naleighna Kai and J. L. Woodson for allowing me to accompany them on this journey.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width"><b>Naleighna Kai</b></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Special thanks goes out to: Sesvalah, J. L. Woodson (for the awesome cover designs for the Knights of the Castle and the Kings of the Castle series), Debra J. Mitchell, J. L. Campbell, Karen D. Bradley, Stephanie M. Freeman, Kelly Peterson, Janine Ingram, Jamyi Joy, Ehryck F. Gilmore, LaVerne Thompson, Kassanna Dwight, Unique M. Hiram, Sandy S., April Bubb, Siera London, Kelsie Maxwell, Brynn Weimer, the Kings of the Castle Ambassadors, Members of Naleighna Kai’s Literary Cafe, the members of NK Tribe Called Success, the members of Namakir Tribe, and to you, my dear readers . . . thank you all for your support.</p>
<p class="subsq">Much love, peace, and joy.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?49072e17